module.exports = __webpack_public_path__ + "static/media/plv.logo.240w.2a11ccd6.png";